export function getHooks() {
  var a = {};

  try {
    a = require("Content/_override/ReferenceDocsHooks");
  } catch (a) {}

  return a;
}